import React from 'react';
import { Text, Skeleton } from '@/components/ui';

interface TextCellProps {
  value?: unknown;
  truncate?: boolean;
  render?: () => React.ReactNode;
}

function TextCell({ value, truncate, render }: TextCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  const displayValue = String(value || '');

  return (
    <Text 
      size="2" 
      className="data-cell__text"
      truncate={truncate}
      title={truncate ? displayValue : undefined}
    >
      {displayValue}
    </Text>
  );
}

export function TextCellSkeleton() {
  return (
    <Skeleton style={{ width: '120px', height: '16px', borderRadius: '4px' }} />
  );
}

export default TextCell;
